import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetLand } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetLandField } from '../../../../../queries/useBudgetLandField';

interface OtherAmountProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const OtherAmount: React.FC<OtherAmountProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [otherAmount, set_otherAmount] = useBudgetLandField<number>(
        propertyGuid,
        (b) => (b.values?.['Site Work']?.['Other, Describe']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Other, Describe': [b.values?.['Site Work']?.['Other, Describe']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Other - Amount';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(otherAmount)}
                />
            ) : (
                <MoneyBox
                    id={'otherAmount-sitework'}
                    allowNegative={false}
                    value={otherAmount}
                    onChange={(value) => set_otherAmount(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
